import React from "react";
import { Link, useLocation, matchPath } from "react-router-dom";
import { useSelector } from "react-redux";
import { navbarLinks } from "../data/navbar-links";
import { LuLogIn } from "react-icons/lu";
import ProfileDropDown from "../components/core/Auth/ProfileDropdown";
import logo from "../assets/Images/logo-rem.png";

function Navbar() {
  const location = useLocation();
  const { token } = useSelector((state) => state.auth);

  const matchRoute = (route) => {
    return matchPath({ path: route }, location.pathname);
  };

  return (
    <div className="flex h-16 bg-amber-300 border-b-2 border-red-400 items-center bg-blue-300 flex-col ">
      <div className="w-11/12 mx-auto flex justify-between flex-col">
        {/* logo */}
       <div  className="w-11/12 mx-auto flex justify-between ">
       <Link to="/">
          <div className=" flex gap-2 lg:text-3xl text-xl justify-center items-center text-pink-5 ">
            <img src={logo} alt="" height={20} className="h-[50px]" />
            {/* <p className='font-mulish font-bold'> <span className='text-pink-300 font-extrabold'>M</span>KPC </p> */}
            <p className="font-mulish font-bold from-blue-400 to-red-500">
              {" "}
              UG <span>L</span>ibrary
            </p>
          </div>
        </Link>

        {/* category */}
        <div className="flex   justify-center items-center ">
          <ul className="flex gap-x-6 text-xl font-bold font-mulish justify-center items-center ">
            {navbarLinks.map((link, index) => (
              <li
                className={`${
                  matchRoute(link?.path)
                    ? "text-caribbeangreen-200 border-b border-black "
                    : "text-richblack-800"
                }`}
                key={index}
              >
                <Link to={link.path}>{link.title}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="flex  justify-center items-center ">
          {token === null && (
            <Link to="/login">
              <button className="flex gap-x-2 items-center p-2 mr- px-4 bg-red-100 text-gray-600 lg:text-xl font-bold font-mulish border  bg-yellow-5 rounded-md">
                <LuLogIn /> Login
              </button>
            </Link>
          )}
          {token !== null && <ProfileDropDown />}
        </div>

       </div>

      </div>
    </div>
  );
}

export default Navbar;
